import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Home16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.46973 0.46973C7.76262 0.176838 8.23749 0.176838 8.53038 0.46973L15.5304 7.46969L14.4697 8.53036L13.75 7.81064V13.4999C13.75 13.9142 13.4142 14.2499 13 14.2499H3C2.58579 14.2499 2.25 13.9142 2.25 13.4999V7.81075L1.53038 8.53036L0.469727 7.46969L7.46973 0.46973ZM8.00006 2.06072L12.25 6.31064V12.7499H10.5V10.75C10.5 9.36929 9.38071 8.25 8 8.25C6.61929 8.25 5.5 9.36929 5.5 10.75V12.7499H3.75V6.31075L8.00006 2.06072ZM7 12.7499H9V10.75C9 10.1977 8.55228 9.75 8 9.75C7.44772 9.75 7 10.1977 7 10.75V12.7499Z'
      fill='currentColor'
    />
  </Svg>
);

Home16.displayName = 'Home16';
export default Home16;
